import React from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { formatCurrency } from '../../../../helpers/currencyMask';

const linkClassnames = 'text-blue-700 underline cursor-pointer';

export default function Currency({ value, link, row, compact }) {
  const hasLink = link && typeof link === 'function';

  // If value is not a number, return the value as is
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) {
    return '$0.00';
  }

  const mainContent = (
    <div>
      <span
        className={classNames({
          'text-[12px]': compact,
          [linkClassnames]: hasLink,
        })}
      >
        {value >= 0 ? '$' : '-$'}
      </span>
      <span
        className={classNames({
          [linkClassnames]: hasLink,
          'text-[12px]': compact,
        })}
      >
        {formatCurrency(value)}
      </span>
    </div>
  );

  if (link && typeof link === 'function') {
    return <Link to={link(row)}>{mainContent}</Link>;
  }

  return mainContent;
}
